import store from '@/core/store'
import vuetify from '@/plugins/vuetify'
import RootPage from '@/views/pages/RootPage.vue'
import router from '@/views/routers'
import exceptionHandler from '@/core/exceptions/ExceptionHandler'
import Vue from 'vue'

class RootPageCreator {
	createInstance() {
		new Vue({
			router,
			store,
			vuetify,
			errorCaptured(error) {
				exceptionHandler.execute(error)
				return false
			},
			render: (h) => h(RootPage),
		}).$mount('#app')
	}

	createBootstrapError() {
		new Vue({
			el: '#app',
			store,
			vuetify,
			render(createElement) {
				return createElement('div', {class: 'ata'})
			},
		})
	}
}

export default new RootPageCreator()
